import { render, staticRenderFns } from "./MaintenanceDetailForm.vue?vue&type=template&id=0ba64bef"
import script from "./MaintenanceDetailForm.vue?vue&type=script&lang=ts"
export * from "./MaintenanceDetailForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports